module.exports = __webpack_public_path__ + "static/media/49.3361ee37.jpg";